import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { bookmarksMetadata, fetchAllEpisodeBookmarks } from '../../actions';
import EmptyState from './EmptyState';
import HighlightsCards from './highlightsCards';

class HighlightsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bookmarksMetadataLoc: bookmarksMetadata,
        }
    }
    componentDidMount() {
        const { userDetails, episodeBookmarks } = this.props;
        if (Object.keys(episodeBookmarks).length < 1) {
            this.setState({ loading: true })
        }
        if (userDetails && userDetails.uid) {
            this.props.fetchAllEpisodeBookmarks(userDetails.uid);
        }
        setTimeout(() => {
            this.setState({ loading: false })
        }, 1500);
    }

    componentDidUpdate(prevProps) {
        const { userDetails, episodeBookmarks } = this.props;
        if (prevProps && (typeof userDetails !== 'undefined' && userDetails !== prevProps.userDetails)) {
            if (userDetails && userDetails.uid) {
                this.props.fetchAllEpisodeBookmarks(userDetails.uid);
            }
        }
        if (prevProps && (typeof episodeBookmarks !== 'undefined' && episodeBookmarks !== prevProps.episodeBookmarks)) {
            if (episodeBookmarks && Object.keys(episodeBookmarks).length > 0) {
                // this.props.fetchAllEpisodeBookmarks(userDetails.uid);
                this.setState({ bookmarksMetadataLoc: bookmarksMetadata });
            }
        }
    }

    render() {
        const { episodeBookmarks, highlightsMap } = this.props;
        const { bookmarksMetadataLoc } = this.state;
        // final Map<String, Map> episodeBookmarks = vm.episodeBookmarks;
        // List<Map> episodeBookmarksList =
        const bookmarkCollectionIds = {};
        Object.values(bookmarksMetadataLoc).forEach((el) =>
            bookmarkCollectionIds[el['collectionId']] =
            (bookmarkCollectionIds[el['collectionId']] ?? 0) +
            Object.keys(el['bookmarks'] ?? {}).length);
        console.dir(bookmarksMetadataLoc);
        console.dir(bookmarkCollectionIds);
        console.dir(highlightsMap);

        if ((!bookmarkCollectionIds || Object.keys(bookmarkCollectionIds).length < 1)
            && (!highlightsMap || Object.keys(highlightsMap).length < 1)) {
            return (<EmptyState imageHeight='200px'
                message="Your Saved Highlights & Bookmarks will show up here." imageName="empty" />)
        }
        return (
            <div>
                <HighlightsCards highlightsMap={highlightsMap} bookmarkCollectionIds={bookmarkCollectionIds} />
            </div>
        )
    }
}


HighlightsPage.propTypes = {
    // loadingState: PropTypes.object,
    loadingUserDetails: PropTypes.bool,
    // fetchError: PropTypes.object,
    userDetails: PropTypes.object,
    episodeBookmarks: PropTypes.object,
    highlightsMap: PropTypes.object,
    fetchAllEpisodeBookmarks: PropTypes.func,
    // getEpisodeReviews: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        // loadingState: state.loadingState,
        // fetchError: state.errorsState,
        episodeBookmarks: state.episodeBookmarks,
        highlightsMap: state.highlights,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchAllEpisodeBookmarks: bindActionCreators(fetchAllEpisodeBookmarks, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(HighlightsPage);